import { render, staticRenderFns } from "./ExchangePopupAfter.vue?vue&type=template&id=5f7935b2&"
import script from "./ExchangePopupAfter.vue?vue&type=script&lang=ts&"
export * from "./ExchangePopupAfter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports